import axios from '../apiEditor';
import qs from 'qs';

export default {
	getKeyPadItemsByKeypadId(keypadId) {
		return axios.get().get(`/editor/keypaditems/getbykeypadid?id=${keypadId}`);
	}
};
